<style>
    :host ::ng-deep .ss-l-class-metaApp .p-sidebar-right {
        z-index: 41105 !important;
    }

    .ss-l-class-metaApp .p-sidebar-right {
        z-index: 41105 !important;
    }

    :host ::ng-deep .p-sidebar-right {
        z-index: 41105 !important;
    }


    .p-sidebar-right {
        z-index: 41105 !important;
    }

    .chip-wrapper {
        max-width: 100%;
        display: block;
        overflow: hidden;
    }

    :host ::ng-deep .s-s-l-chips-comments .p-chip img {
        width: 1.5rem !important;
        height: 1.5rem !important;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }

    :host ::ng-deep .s-s-l-chips-comments .p-chip .p-chip-text {
        display: inline-block;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 0.25rem;
    }

    .s-s-l-badgeChat {
        position: absolute;
        top: -15px;
        right: -10px;
    }

    :host ::ng-deep .s-s-l-chips-comments .p-chip {
        margin-right: 0px !important;
    }

    :host ::ng-deep p-avatar.avatar-primary .p-avatar {
        background: #2196f3 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-info .p-avatar {
        background: #00bcd4 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-success .p-avatar {
        background: #4caf50 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-warning .p-avatar {
        background: #ff9800 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-danger .p-avatar {
        background: #f44336 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-contrast .p-avatar {
        background: #222 !important;
        color: #fff !important;
    }

    :host ::ng-deep p-avatar.avatar-secondary .p-avatar {
        background: #9c27b0 !important;
        color: #fff !important;
    }

    :host ::ng-deep .s-s-l-filtrosChat .p-multiselect {
        width: 100%;
    }

    .rotate-180 {
        transform: rotate(180deg);
    }

    .collapsible {
        display: grid;
        grid-template-rows: 1fr;
        transition: grid-template-rows .25s, opacity .25s;
        opacity: 1;
    }

    .collapsible__inner {
        overflow: hidden;
    }

    .collapsible.collapsed {
        grid-template-rows: 0fr;
        opacity: 0;
    }

    .collapsible__inner>* {
        min-height: 0;
    }

    :host ::ng-deep .ss-badge-chat-filter {
        position: absolute;
    }

    :host ::ng-deep .ss-badge-circle {
        min-width: 1.5rem;
        width: 1.5rem;
        height: 1.5rem;
        line-height: 1.5rem;
        padding: 0;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.75rem;
    }

    .ss-chat-thumb {
        width: 28px;
        height: 28px;
        border-radius: 6px;
        object-fit: cover;
        flex: 0 0 28px;
    }

    .ss-l-header-comentarios .ss-l-refresh-btn,
    .ss-l-header-notificacoes .ss-l-refresh-btn {
        opacity: 1;
        transition: opacity 0.2s;
    }

    .ss-l-header-comentarios:hover .ss-l-refresh-btn,
    .ss-l-header-notificacoes:hover .ss-l-refresh-btn {
        opacity: 1;
    }

    @media (max-width: 768px) {
        .ss-l-header-comentarios .ss-l-refresh-btn,
        .ss-l-header-notificacoes .ss-l-refresh-btn {
            opacity: 1;
        }
    }

    .one-line-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        /* garante que o ellipsis funcione */
        min-width: 0;
        /* evita quebra em flex containers */
    }

    /* MOBILE: mantém contido para não estourar */
    @media (max-width: 768px) {
        .collapsible__inner {
            overflow: hidden;
        }
    }

    /* DESKTOP: libera overlay dentro do próprio bloco */
    @media (min-width: 769px) {
        .collapsible__inner {
            overflow: visible;
        }
    }
</style>



<p-sidebar #commentsSidebarRef [modal]="false" [(visible)]="chatVisible" class="ss-g-custom-sidebar-width ss-l-class-metaApp"
    position="right" [transitionOptions]="'.5s cubic-bezier(.25,.8,.25,1)'" (onHide)="desconectarChat()">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 ss-l-header-comentarios">
            <h5 class="m-0 flex align-items-center gap-2">
                Comentários
                <p-badge *ngIf="unreadCount > 0" [value]="unreadCommentsCountLabel" severity="danger"
                    class="inline-flex align-items-center" styleClass="ss-badge-circle">
                </p-badge>
            </h5>
            <i class="pi pi-refresh cursor-pointer text-color-secondary ss-l-refresh-btn"
                [class.pi-spin]="loadingComments"
                (click)="refreshComments(); $event.stopPropagation()"
                pTooltip="Atualizar comentários" tooltipPosition="bottom"></i>
        </div>
    </ng-template>
    <!-- Header -->
    <div class="mt-2 mb-0">
        <div class="card shadow-none pb-0">
            <div class="flex align-items-center gap-2 mb-2">
                <span class="p-input-icon-left flex-1">
                    <i class="pi pi-search"></i>
                    <input pInputText [(ngModel)]="searchTerm" placeholder="Buscar comentário ou ID"
                        (ngModelChange)="onSearchChange()" class="w-full" />
                </span>
                <!-- Botão menu ao lado -->
                <button pButton pRipple type="button" icon="bi bi-three-dots-vertical" (click)="menu.toggle($event)"
                    disabled="true" style="min-width:2.5rem;min-height:2.5rem"></button>
                <p-menu #menu [model]="itemsButtons" [popup]="true" class="ss-g-custom-menu-right"></p-menu>
            </div>
            <p-tabMenu [model]="tabsOptions" [(activeItem)]="activeTabItem"></p-tabMenu>
        </div>
    </div>


    <!-- Skeleton template compartilhado entre as 3 abas -->
    <ng-template #skeletonComments>
        <div class="mb-5 mt-5"></div>
        <div *ngFor="let i of [1,2,3]" class="card shadow-none">
            <div class="flex align-items-center mb-2">
                <p-skeleton shape="circle" size="3rem" styleClass="mr-2 flex-shrink-0"></p-skeleton>
                <div class="flex-1">
                    <p-skeleton width="55%" height="0.9rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="35%" height="0.75rem"></p-skeleton>
                </div>
            </div>
            <p-skeleton width="80%" height="0.75rem" styleClass="mb-3"></p-skeleton>
            <p-skeleton width="55%" height="2.5rem" borderRadius="16px"></p-skeleton>
        </div>
    </ng-template>

    <div class="flex flex-column">
        <!-- tabs separadas -->
        <div [ngSwitch]="activeTabIndex" class="mt-0">
            <!-- Aba Todos -->
            <div *ngSwitchCase="0">
                <ng-container *ngIf="loadingComments; else todosContent">
                    <ng-container *ngTemplateOutlet="skeletonComments"></ng-container>
                </ng-container>
                <ng-template #todosContent>
                <div *ngIf="comments?.length" class="mb-5 mt-5"></div>
                <!-- Lista simples, seu layout atual -->
                <ng-container *ngIf="comments?.length; else semComentarios">
                    <div *ngFor="let comment of comments" class="card shadow-none relative cursor-pointer hover:surface-hover transition-colors transition-duration-150"
                        (click)="abrirChat(comment)"
                        [ngClass]="{ 'bg-primary-reverse': !comment.is_read, 'opacity-70': comment.is_read }">
                        <div class="flex align-items-center mb-2">
                            <!-- Avatar inicial -->

                            <p-avatar [label]="getAvatarLabel(comment)" size="large" class="mr-2 "></p-avatar>


                            <div class="flex-1">
                                <div class="flex align-items-center justify-content-between">
                                    <span class="font-semibold mb-1">{{ comment.from_name || comment.user_chat_id
                                        }}</span>
                                    <span class="text-xs text-color-secondary flex align-items-center gap-2">
                                        {{ comment.created_at | timeago:'pt_BR' }}
                                        <span *ngIf="!comment.is_read" style="width: 7px;
                                               height: 7px;
                                               flex-shrink: 0;
                                               margin-left: 6px;
                                               border-radius: 50%;
                                               background-color: #f44336;
                                               display: inline-block;
                                               align-self: flex-start;">
                                        </span>
                                    </span>
                                </div>

                                <div class="text-xs" style="margin-top:-0.25rem">
                                    {{ comment.content | slice:0:50 }}{{ comment.content?.length > 50 ? '...' : '' }}
                                    <span *ngIf="!comment.is_read" class="dot-indicator bg-primary"></span>
                                </div>
                            </div>
                        </div>
                        <!-- p-chip com imagem igual à sua multiselect -->
                        <div class="flex align-items-center mt-1">
                            <div class="chip-wrapper hover:shadow-8 border-round-2xl">
                                <p-chip [style]="{
                              'height': '2.5rem',
                              'padding': '0px 0.5rem 0 0rem',
                              'max-width': '100%'
                            }" styleClass="mr-2 text-xs flex items-center" class="s-s-l-chips-comments"
                                    (click)="onChipClick($event, comment)" pTooltip="Abrir página do slick"
                                    tooltipPosition="top">
                                    <img [src]="getSourceIcon(comment.live_source_id)" />
                                    <span class="flex-1 min-w-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ comment.live_description || 'Sem descrição' }}</span>
                                    <span class="flex-shrink-0 text-2xl ml-0 ">↗</span>
                                </p-chip>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #semComentarios>
                    <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                        <i class="pi pi-comments text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                        <span class="text-xl font-semibold text-900 mb-2">Nenhum comentário encontrado</span>
                        <span class="text-sm text-400 font-light mb-3" style="max-width: 400px;">Os comentários dos seus clientes vão aparecer aqui.</span>
                    </div>
                </ng-template>
                </ng-template><!-- /todosContent -->
            </div>
            <!-- Aba Slicks -->
            <div *ngSwitchCase="1">
                <ng-container *ngIf="loadingComments; else slicksContent">
                    <ng-container *ngTemplateOutlet="skeletonComments"></ng-container>
                </ng-container>
                <ng-template #slicksContent>
                <ng-container *ngIf="groupedBySlicks.length; else semComentarios">
                    <ng-container *ngFor="let group of groupedBySlicks">
                        <!-- Header do Slick -->
                        <div class="flex align-items-center mb-5 mt-5" style="gap: 0.75rem;">
                            <!-- Thumbnail -->
                            <img [src]="group.thumbnail || 'assets/img/no-thumb.png'" alt="thumb"
                                style="width:36px; height:36px; border-radius:8px; object-fit:cover; flex-shrink:0;" />

                            <!-- Descrição (uma linha, ellipsis, ocupa tudo que sobrar) -->
                            <span class="font-semibold text-base one-line-ellipsis flex-1"
                                style="min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                {{ group.live_description || 'Sem descrição' }}
                            </span>

                            <!-- Contador à direita -->
                            <span class="ml-2 text-xs text-color-secondary" style="flex-shrink:0;">
                                ({{ group.comments.length - group.unread }}/{{ group.comments.length }})
                            </span>
                        </div>

                        <ng-container *ngFor="let comment of group.comments">
                            <!-- Card de comentário (copie igual da aba Todos) -->
                            <div class="card shadow-none relative cursor-pointer hover:surface-hover transition-colors transition-duration-150" (click)="abrirChat(comment)"
                                [ngClass]="{ 'bg-primary-reverse': !comment.is_read, 'opacity-70': comment.is_read }">
                                <div class="flex align-items-center mb-2">
                                    <p-avatar [label]="getAvatarLabel(comment)" size="large" class="mr-2"></p-avatar>
                                    <div class="flex-1">
                                        <div class="flex align-items-center justify-content-between">
                                            <span class="font-semibold mb-1">{{ comment.from_name ||
                                                comment.user_chat_id }}</span>
                                            <span class="text-xs text-color-secondary flex align-items-center gap-2">
                                                {{ comment.created_at | timeago:'pt_BR' }}
                                                <span *ngIf="!comment.is_read"
                                                    style="width: 7px; height: 7px; flex-shrink: 0; margin-left: 6px; border-radius: 50%; background-color: #f44336; display: inline-block; align-self: flex-start;"></span>
                                            </span>
                                        </div>
                                        <div class="text-xs" style="margin-top:-0.25rem">
                                            {{ comment.content | slice:0:50 }}{{ comment.content?.length > 50 ? '...' :
                                            '' }}
                                            <span *ngIf="!comment.is_read" class="dot-indicator bg-primary"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex align-items-center mt-1">
                                    <div class="chip-wrapper ">
                                        <p-chip [style]="{
                                'height': '2.5rem',
                                'padding': '0px 0.5rem 0 0rem',
                                'max-width': '100%'
                              }" styleClass="mr-2 text-xs flex items-center" class="s-s-l-chips-comments"
                                            (click)="onChipClick($event, comment)" pTooltip="Abrir página do slick"
                                            tooltipPosition="top">
                                            <img [src]="getSourceIcon(comment.live_source_id)" />
                                            <span class="flex-1 min-w-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ comment.live_description || 'Sem descrição' }}</span>
                                            <span class="flex-shrink-0 ml-1 text-color-secondary">↗</span>
                                        </p-chip>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <!-- Divider entre grupos -->
                        <p-divider />
                    </ng-container>
                </ng-container>
                <ng-template #semComentarios>
                    <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                        <i class="pi pi-comments text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                        <span class="text-xl font-semibold text-900 mb-2">Nenhum comentário encontrado</span>
                        <span class="text-sm text-400 font-light mb-3" style="max-width: 400px;">Os comentários dos seus clientes vão aparecer aqui.</span>
                    </div>
                </ng-template>
                </ng-template><!-- /slicksContent -->
            </div>
            <!-- Aba Usuários -->
            <div *ngSwitchCase="2">
                <ng-container *ngIf="loadingComments; else usuariosContent">
                    <ng-container *ngTemplateOutlet="skeletonComments"></ng-container>
                </ng-container>
                <ng-template #usuariosContent>
                <ng-container *ngIf="groupedByUser.length; else semComentarios">
                    <ng-container *ngFor="let group of groupedByUser">
                        <!-- Header do usuário -->
                        <div class="flex align-items-center mb-5 mt-5" style="gap: 0.75rem;">
                            <!-- Ícone de usuário -->
                            <span class="bi bi-person-circle"
                                style="font-size:22px; flex-shrink:0; margin-right:6px;"></span>

                            <!-- Nome do usuário, uma linha, ellipsis, ocupa o centro -->
                            <span class="font-semibold text-base one-line-ellipsis flex-1"
                                style="min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                {{ group.from_name || group.user_chat_id }}
                            </span>

                            <!-- Contador à direita -->
                            <span class="ml-2 text-xs text-color-secondary" style="flex-shrink:0;">
                                ({{ group.comments.length - group.unread }}/{{ group.comments.length }})
                            </span>
                        </div>

                        <ng-container *ngFor="let comment of group.comments">
                            <!-- Card de comentário (mesmo da aba Todos) -->
                            <div class="card shadow-none relative cursor-pointer hover:surface-hover transition-colors transition-duration-150" (click)="abrirChat(comment)"
                                [ngClass]="{ 'bg-primary-reverse': !comment.is_read, 'opacity-70': comment.is_read }">
                                <div class="flex align-items-center mb-2">
                                    <p-avatar [label]="getAvatarLabel(comment)" size="large" class="mr-2"></p-avatar>
                                    <div class="flex-1">
                                        <div class="flex align-items-center justify-content-between">
                                            <span class="font-semibold mb-1">{{ comment.from_name ||
                                                comment.user_chat_id }}</span>
                                            <span class="text-xs text-color-secondary flex align-items-center gap-2">
                                                {{ comment.created_at | timeago:'pt_BR' }}
                                                <span *ngIf="!comment.is_read"
                                                    style="width: 7px; height: 7px; flex-shrink: 0; margin-left: 6px; border-radius: 50%; background-color: #f44336; display: inline-block; align-self: flex-start;"></span>
                                            </span>
                                        </div>
                                        <div class="text-xs" style="margin-top:-0.25rem">
                                            {{ comment.content | slice:0:50 }}{{ comment.content?.length > 50 ? '...' :
                                            '' }}
                                            <span *ngIf="!comment.is_read" class="dot-indicator bg-primary"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex align-items-center mt-1">
                                    <div class="chip-wrapper ">
                                        <p-chip [style]="{
                                'height': '2.5rem',
                                'padding': '0px 0.5rem 0 0rem',
                                'max-width': '100%'
                              }" styleClass="mr-2 text-xs flex items-center" class="s-s-l-chips-comments"
                                            (click)="onChipClick($event, comment)" pTooltip="Abrir página do slick"
                                            tooltipPosition="top">
                                            <img [src]="getSourceIcon(comment.live_source_id)" />
                                            <span class="flex-1 min-w-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ comment.live_description || 'Sem descrição' }}</span>
                                            <span class="flex-shrink-0 ml-1 text-color-secondary">↗</span>
                                        </p-chip>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <!-- Divider entre usuários -->
                        <p-divider />
                    </ng-container>
                </ng-container>
                <ng-template #semComentarios>
                    <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                        <i class="pi pi-comments text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                        <span class="text-xl font-semibold text-900 mb-2">Nenhum comentário encontrado</span>
                        <span class="text-sm text-400 font-light mb-3" style="max-width: 400px;">Os comentários dos seus clientes vão aparecer aqui.</span>
                    </div>
                </ng-template>
                </ng-template><!-- /usuariosContent -->
            </div>

            <div *ngIf="hasMoreComments && !loadingComments" class="mt-3 text-center">
                <button pButton type="button" label="Carregar mais" [loading]="isLoadingMoreComments"
                    [disabled]="isLoadingMoreComments" (click)="carregarMaisComentarios()" class="p-button-outlined">
                </button>
            </div>
        </div>

        <!-- tabs separadas -->
    </div>
</p-sidebar>

<p-sidebar #chatSidebarRef [(visible)]="chatSidebarVisible" [modal]="false" position="right"
    [style]="{ width: '480px', maxWidth: '100vw', 'z-index': 1202 }" (onShow)="renderChatApp = true"
    (onHide)="desconectarChat()" class="ss-g-custom-sidebar-width ss-l-class-metaApp"
    [transitionOptions]="'.5s cubic-bezier(.25,.8,.25,1)'">
    <ng-template pTemplate="header">
        <h5 class="m-0">Chat</h5>
        <!-- Você pode colocar um botão de fechar se quiser -->
    </ng-template>
    <div class="flex flex-column h-full" #overlayHost>
        <div class="card shadow-none">
            <div class="flex align-items-center cursor-pointer" (click)="toggleChatFilters()"
                [ngClass]="{ 'mb-4': !filtersCollapsed }" style="gap: 0.75rem;">
                <!-- Seta para voltar (fecha apenas o chat atual) -->
                <i class="pi pi-arrow-left text-xl" (click)="closeChatSidebar($event)"></i>

                <!-- thumbnail + descrição: ocupa o espaço central -->
                <div class="flex align-items-center gap-2 flex-1" style="min-width: 0;">
                    <img [src]="selectedComment?.thumbnail || 'assets/img/no-thumb.png'" alt="thumb"
                        class="ss-chat-thumb" />
                    <span class="font-bold text-base one-line-ellipsis">
                        {{ selectedComment?.live_description || 'Sem descrição' }}
                    </span>
                </div>



                <!-- Ícone filtro alinhado à direita -->
                <div class="relative ml-auto" style="display:inline-block;">
                    <i class="pi pi-filter text-xl"></i>
                    <p-badge *ngIf="hasActiveChatFilters()" severity="danger" styleClass="ml-1"
                        class="s-s-l-badgeChat"></p-badge>
                </div>
            </div>

            <div class="collapsible" [class.collapsed]="filtersCollapsed">
                <div class="collapsible__inner" [ngStyle]="{ 'overflow': (filtersCollapsed || isMobile) ? 'hidden' : 'visible' }">
                    <div class="flex flex-column gap-4">
                        <!-- 🔍 Input de busca -->
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-search"></i>
                            <input #chatSearchInput pInputText [(ngModel)]="searchTermChat"
                                placeholder="Buscar por nome ou ID..." (ngModelChange)="onChatFilterChange()"
                                class="w-full" />
                        </span>

                        <!-- MultiSelect respondida/não respondida -->
                        <p-multiSelect [options]="statusOptions" [(ngModel)]="selectedStatuses"
                            [appendTo]="isMobile ? overlayHost : null" (onChange)="onChatFilterChange()"
                            defaultLabel="Respondida / Não respondida / Todas" class="w-full s-s-l-filtrosChat"
                            [maxSelectedLabels]="2" display="chip">
                        </p-multiSelect>
                        <!-- Limpar filtros -->
                        <button pButton type="button" label="Limpar filtros" icon="" class="p-button-outlined w-full"
                            (click)="clearChatFilters()">
                        </button>
                    </div>
                </div>
            </div>


        </div>
        <div class="flex-1 min-h-0">
            <app-chat-app *ngIf="renderChatApp" [showSidebar]="true" [chatId]="selectedRoomId || ''" [admin]="true"
                [storeId]="storeId"
                [isLoadingMessages]="isLoadingChatMessages" [chatSidebarVisible]="chatSidebarVisible"
                [staticMessages]="selectedChatMessages" [searchTerm]="searchTermChat" [statusFilter]="selectedStatuses"
                (messageCreated)="onChatMessageCreated($event)"
                (messageRemoved)="onChatMessageRemoved($event)">
            </app-chat-app>
        </div>
    </div>
</p-sidebar>


<p-sidebar [(visible)]="notificationsVisible" appendTo="body" [modal]="true" position="right"
    class="ss-l-class-metaApp notificationsSidebar" [transitionOptions]="'.5s cubic-bezier(0, 0, 0.2, 1)'"
    styleClass="layout-profile-sidebar w-full sm:w-25rem ss-global-sidebar" (onShow)="loadPushs(1)">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 ss-l-header-notificacoes mb-2" style="padding-left: 0.75rem;">
            <h5 class="m-0 flex align-items-center gap-2">
                Notificações
                <p-badge *ngIf="unreadCount > 0" [value]="unreadCountLabel" severity="danger"
                    class="inline-flex align-items-center" styleClass="ss-badge-circle">
                </p-badge>
            </h5>
            <i class="pi pi-refresh cursor-pointer text-color-secondary ss-l-refresh-btn"
                [class.pi-spin]="loadingPushs"
                (click)="refreshPushs(); $event.stopPropagation()"
                pTooltip="Atualizar notificações" tooltipPosition="bottom"></i>
        </div>
    </ng-template>
    <div class="flex flex-column mx-auto md:mx-0">
        <div class="flex flex-column mt-0 mx-auto md:mx-0 w-full">

            <!-- Skeleton notificações -->
            <ng-template #skeletonPushs>
                <div *ngFor="let i of [1,2,3]"
                    class="flex align-items-start surface-border mb-3 p-3 border-1 surface-border border-round gap-3">
                    <p-skeleton shape="circle" size="2rem" styleClass="flex-shrink-0"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="90%" height="0.8rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="30%" height="0.7rem"></p-skeleton>
                    </div>
                </div>
            </ng-template>

            <ng-container *ngIf="loadingPushs; else pushsContent">
                <ng-container *ngTemplateOutlet="skeletonPushs"></ng-container>
            </ng-container>
            <ng-template #pushsContent>
            <ng-container *ngIf="pushs.length > 0; else noNotifications">
                <ul class="list-none m-0 p-0">
                    <li *ngFor="let push of pushs">
                        <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150 w-full"
                            [ngClass]="{ 'bg-primary-reverse': !push.is_read, 'opacity-70': push.is_read }"
                            (click)="marcarComoLido(push)">

                            <!-- Ícone pela categoria -->
                            <span class="flex align-items-center justify-content-center mr-3">
                                <i *ngIf="push.category === 'news'" class="bi bi-newspaper text-xl text-primary"></i>
                                <i *ngIf="push.category === 'comments'"
                                    class="bi bi-chat-dots-fill text-xl text-primary"></i>
                                <i *ngIf="push.category === 'account'"
                                    class="bi bi-person-fill-gear text-xl text-primary"></i>
                                <i *ngIf="!push.category" class="pi pi-bell text-xl text-primary"></i>
                            </span>

                            <div class="flex flex-column flex-1">
                                <!-- Título + ponto indicador -->
                                <div class="flex justify-content-between">
                                    <span class="mb-1 font-bold text-lg">{{ push.title }}</span>
                                    <span *ngIf="!push.is_read" style="width: 5px;
                                        height: 5px;
                                        flex-shrink: 0;
                                        margin-left: 8px;
                                        border-radius: 50%;
                                        background-color: var(--primary-color);
                                        display: inline-block;
                                        align-self: flex-start;"></span>
                                </div>

                                <!-- Corpo -->
                                <p class="m-0" [ngStyle]="{ 'font-weight': !push.is_read ? 'bold' : 'normal' }">
                                    {{ push.body }}
                                </p>

                                <!-- Imagem opcional -->
                                <div *ngIf="push.image" class="mt-2 px-2">
                                    <img [src]="push.image" alt="" class="w-full border-round block mx-auto"
                                        loading="lazy" decoding="async" style="height:auto; object-fit:contain"
                                        (error)="onPushImageError(push)" />
                                </div>

                                <!-- Tempo -->
                                <small class="text-color-secondary mt-1">
                                    {{ push.created_at | timeago:'pt_BR' }}
                                </small>
                            </div>
                        </a>
                    </li>
                </ul>

                <div *ngIf="hasMore" class="mt-3 text-center">
                    <button pButton type="button" label="Carregar mais" (click)="loadPushs(pagination.page + 1)"
                        [icon]="loadingMorePushs ? 'pi pi-spin pi-spinner' : ''"
                        [disabled]="loadingMorePushs"
                        class="p-button-outlined"></button>
                </div>
            </ng-container>

            <ng-template #noNotifications>
                <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                    <i class="bi bi-bell-slash text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                    <span class="text-xl font-semibold text-900 mb-2">Nenhuma notificação encontrada</span>
                    <span class="text-sm text-400 font-light mb-3" style="max-width: 400px;">As notificações da sua loja vão aparecer aqui.</span>
                </div>
            </ng-template>
            </ng-template><!-- /pushsContent -->
        </div>

        <!---->

    </div>
</p-sidebar>
